import React from 'react';

import { RowProps } from '../types.ts';
import { Row as RowComponent } from './Row.tsx';

const genericMemo: <T>(
  component: T,
  propsAreEqual?: (prevProps: Readonly<RowProps<T>>, nextProps: Readonly<RowProps<T>>) => boolean,
) => T = React.memo;

export const MemoizedRow = genericMemo(RowComponent, (prevProps, nextProps) => {
  const areIDsEqual = prevProps.row.id === nextProps.row.id;
  const rowIndex = prevProps.row.index;
  const animateEnterEqual = prevProps.animateEnter === nextProps.animateEnter;
  const originalEqual = prevProps.row.original === nextProps.row.original;

  if (!areIDsEqual || !animateEnterEqual || !originalEqual) return false;

  return prevProps.isSelected === null
    ? prevProps.customBackgroundColor === nextProps.customBackgroundColor
    : prevProps.isSelected === nextProps.isSelected &&
        rowIndex !== nextProps.activeRowIndex &&
        rowIndex !== prevProps.activeRowIndex &&
        prevProps.customBackgroundColor === nextProps.customBackgroundColor;
});
